import { BaseFooter } from '@morph-mapper/ui';
import { Text, TextInput } from '@mantine/core';
import { MdOutlineOutput } from 'react-icons/md';
import { useFooter } from './use-footer';

/**
 * Footer component for the code editor.
 * Displays the output of the code entry.
 *
 * @returns {JSX.Element} The Footer component.
 */

interface FooterProps {
  value: string | undefined;
}

export const Footer = ({ value }: FooterProps) => {
  const { output } = useFooter(value);

  return (
    <BaseFooter>
      <Text>Entry Output</Text>
      <TextInput
        disabled
        value={output}
        icon={<MdOutlineOutput />}
        style={{
          flex: 1,
          marginLeft: '1.5rem',
        }}
        styles={{
          input: {
            ':disabled': {
              fontWeight: 500,
              color: 'black',
            },
          },
        }}
      />
    </BaseFooter>
  );
};
